// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoBookOutlinedSvg from "@fishx/icons-svg/es/asn/PtoBookOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoBookOutlined = function PtoBookOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoBookOutlinedSvg
  }));
};

PtoBookOutlined.displayName = 'PtoBookOutlined';
export default React.forwardRef(PtoBookOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoBookOutlined.js
// module id = 3880
// module chunks = 0